module.exports = __webpack_public_path__ + "science.safer-speeds.discs.jpg?b959fb2d3dd88cfc077e5681c5551518";